// Given a list of allowed roles to view,
// and a list of permissions the current user has,
// return true if the user has a permission included in the allowed roles
export const hasPermissionToView = function(allowedRoles, userPermissions) {
  for (let i = 0; i < allowedRoles.length; i++) {
    if (userPermissions[allowedRoles[i]] === true) {
      return true;
    }
  }

  return false;
};
